export default {
  timetable: "Timetable",
  yourCourses: "Your lessons",
  "There are no events on this day.": "There are no events on this date",
  Today: "Today",
  Month: "Month",
  Week: "Week",
  Day: "Day",
  Year: "Year",
  More: "More",
  "Application for authorization of exceptional absence": "Application for exceptional leave of absence",
  "Add a new event": "Add a new event",
};
